<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-02 16:18:09
-->
<template>
  <div>
    <div class="top">
        <div class="top-btn">
        <el-button v-if="codeData.indexOf('97') != -1"  @click="openAddPage"  type="primary">新增变量</el-button>
        <el-button v-if="codeData.indexOf('98') != -1"  style="background: #ecf5ff;color:#176de6" @click="addGroup" type="primary">分组管理</el-button>
        </div>
        <div class="search">
            <a-select v-model="groupId" style="width: 418px; margin-right: 20px"  placeholder="按分组名称筛选" >
            <a-select-option :value="item.id" v-for="(item,index) in grouplist" :key="index">{{item.groupName}}</a-select-option>
            </a-select>
            <a-input
                v-model="searchVariableName"
                placeholder="变量名称"
                style="width: 173px; margin-right: 20px"
            />
            <el-button type="primary" @click="search">查询</el-button>
        </div>
    </div>
    <coententTable
      @handleSizeChange="handleSizeChange"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="variableListData"
      :customSlot="customSlot"
      :y="height"
      :loading="loading"
    >
     <template v-slot:variableType="scopeVal">
				{{scopeVal.scope.variableType==0?'单行文本':scopeVal.scope.variableType==1?'多行文本':'图片'}}
		</template>
        <template v-slot:variableValue="scopeVal">
				<div v-if="scopeVal.scope.variableType != 2">{{scopeVal.scope.variableValue}}</div>
                <img class="img" v-if="scopeVal.scope.variableType == 2" :src=" imgIp + scopeVal.scope.variableValue"/>
		</template>
        <template v-slot:operation="scopeVal">
            <div style="display:flex">
                 <div v-if="codeData.indexOf('99') != -1" style="margin-right:14px;width:66px"  class="btnTwo" @click="useVariable(scopeVal.scope,scopeVal.scope.id)">调用变量</div>
              <div class="btnTwo"  v-if="codeData.indexOf('100') != -1" @click="editVariable(scopeVal.scope.id)" style="margin-right:14px">编辑</div>
              <div v-if="codeData.indexOf('101') != -1" @click="showDeleteVariable(scopeVal.scope)"  class="btnThree">删除</div>
            </div>
        </template>
    </coententTable>
    <addCustom @closeThree="closeThree"  @close="close" :visible="visible" :editVariableId="editVariableId"></addCustom>
    <groupManagement  @close="closeTwo" :visible="visibleTwo"/>
     <el-dialog
      title="确认删除变量?"
      :visible.sync="deleteVariableShow"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span
        >变量删除后的,已被引用的地方将会丢失变量内容。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVariableShow = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteVariable"
          >确认删除</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="'你正在调用变量-'+item.variableName"
      :visible.sync="deleteVariableTip"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <a-textarea :rows="6"  v-model="valueText"/>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="deleteVariableTip = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import addCustom from './add_custom_vanables.vue';
import groupManagement from './group_management.vue';
import {variableList,variableDel,variableUse,variableGrouplist} from './custom_variables.js';
import { message } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
export default {
    data() {
        return {
        visible:false,
        visibleTwo:false,
        deleteShow:false,
        deleteVariableShow:false,
        deleteVariableTip:false,
        selectName: "管理员姓名",
        selectValue: "",
        groupId:undefined,
        searchVariableName: "",
        selectArr: [
            {
            label: "管理员姓名",
            value: "useName",
            },
            {
            label: "手机号",
            value: "phone",
            },
        ],
        columns: [
            {
            title: "变量名称",
            dataIndex: "variableName",
            ellipsis: true,
            customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        }
            },
            {
            title: "变量类型",
            dataIndex: "variableType",
           ellipsis: true,
            width: 120,
            scopedSlots: { customRender: 'variableType' },
            },
            {
            title: "变量值",
            dataIndex: "variableValue",
            scopedSlots: { customRender: 'variableValue' },
            ellipsis: true,
            width: 120,
            },
            {
            title: "分组",
            dataIndex: "groupName",
            ellipsis: true,
            width: 120,
            },
            {
            title: "操作",
            dataIndex: "operate",
            scopedSlots: { customRender: "action" },
             fixed: "right",
              width: 260,
            },
        ],
        //分页
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
            pageSizeOptions: ["10", "20", "30"],
        },
        dataSource: [],
        customSlot:[
            {
                name:'variableValue',
                customRender:'variableValue',
            },
            {
                name:'variableType',
                customRender:'variableType',
            },
        ],
        //数据列表
        variableListData:[],
        deleteVariableId:'',//待删除变量id
        editVariableId:'',//待编辑变量内容
        grouplist:[],//分组列表
        valueText:'',
        item:{},
        height:0,
        codeData:[],
        loading:false,
    };
},
    components: {
        coententTable,
        addCustom,
        groupManagement,
    },
    mounted() {
        this.getVariableList()
        this.getGrouplist()
         this.height = document.documentElement.clientHeight - 412;
         window.onresize = () => {
        return (() => {
          this.height = document.documentElement.clientHeight - 412;
        })();
      };
      this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    },
    methods: {
        // 切换 搜索
        selectFn(value) {
            this.selectValue = value;
        },
        //分页切换
        onShowSizeChange(current) {
            this.pagination.current = current
            this.getVariableList()
        },
        handleSizeChange(pageSize) {
            this.pagination.pageSize =pageSize
            this.pagination.current = 1
            this.getVariableList()
        },
        openAddPage(){
            this.editVariableId = ''
            this.visible = true;
        },
        addGroup(){
            this.visibleTwo = true;
        },
        close(){
            this.visible = false;
            this.getVariableList()
        },
        closeThree(){
             this.visible = false;
        },
        closeTwo(){
            this.visibleTwo = false;
        },
        editVariable(variableId){
            this.editVariableId = variableId
            this.visible = true;
        },
        showDeleteVariable(item) {
            this.deleteVariableId = item.id
            this.deleteVariableShow = true;
        },
        //获取列表
        getVariableList(){
            const _this = this
            this.loading = true;
            let reqData = {
                "current": _this.pagination.current,
                "groupId": _this.groupId,
                "siteId": sessionStorage.getItem('siteId'),
                "size": _this.pagination.pageSize,
                "variableName": _this.searchVariableName
            }
            variableList(reqData).then(res=>{
                if(res.code == 0){
                    _this.variableListData = res.data.records
                    _this.pagination.total = res.data.total
                    _this.pagination.current = res.data.current
                     if(_this.variableListData.length == 0 && this.pagination.current != 1){
                          _this.pagination.current = this.pagination.current - 1;
                          _this.getVariableList();
                    }
                }
                this.loading = false;
            })
        },
        // 删除变量
        deleteVariable(){
            this.deleteShow = true;
            variableDel({id:this.deleteVariableId}).then(res=>{
                if(res.code == 0){
                    message.success(res.msg)
                    this.deleteVariableShow = false;
                    this.deleteShow = false;
                    this.getVariableList()
                }
            })
        },
        // 调用变量
        useVariable(item,id){
            variableUse({id: id}).then(res=>{
                if(res.code==0){
                    this.deleteVariableTip = true;
                    this.valueText = res.data.code;
                    this.item = item;
                    //message.success(res.msg)
                }
            })
        },
        getGrouplist(){
            const _this = this
            variableGrouplist({siteId: sessionStorage.getItem('siteId')}).then(res=>{
                if(res.code==0){
                    this.grouplist = res.data
                }
            })
        },
        search(){
            this.pagination.current = 1;
            this.getVariableList()
        }
    }
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 480px;
  }
  /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.deletBox{
    background: red !important;
   .el-message-box__message{
    color:#ccc !important;
   }
}
.img{
    width:121px;
    height:80px;
    border-radius: 5px;
}
/deep/ .el-dialog {
  font-weight: 600;
}
/deep/ .el-dialog__body {
  color: #909399;
  font-weight: 400;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
/deep/ .el-dialog__body {
  padding-top: 15px;
}
.top-btn{
  display: flex;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
 .el-button--primary {
  background: #176de6;
}
</style>